import { withStyles, SnackbarProvider as NuiSnackbarProvider } from '@lsy-netline-ui/netline-ui';

import styles from './SnackbarProvider.styles';

const SnackbarProvider = NuiSnackbarProvider;

export default withStyles(styles)(SnackbarProvider);
